import { Component, OnInit, Input } from '@angular/core';
import { Page } from 'libraries/Page';

@Component({
	selector: 'page-preview',
	templateUrl: './page-preview.component.html',
	styleUrls: ['./page-preview.component.css']
})
/**DisplayPageComponent is a component to display one page of a sign
 * <app-page-preview *ngFor="let page of pages" [page]="page"></app-page-preview>*/
export class PagePreviewComponent implements OnInit {
	/**This is a property that you should binded from the place you are using this component */
	@Input('page') page: Page;
	@Input('highlight') highlight: boolean;

	constructor() {}

	/**This will check if you actually binded a page if not, it is gonna assign the default page
	 * which is a Page with the default 3 pages set un Page*/
	ngOnInit() {
		if (!this.page) {
			console.warn('Warning You should set property page of page-preview component');
			this.page = new Page();
		}
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/page-preview/page-preview.component.ts